import { BrandContextSection } from '../BrandContextSection/BrandContextSection';
import { CreativeBriefSnapshotSection } from '../CreativeBriefSnapshotSection/CreativeBriefSnapshotSection';
import { CustomerUnderstandingSection } from '../CustomerUnderstandingSection/CustomerUnderstandingSection';
import { DetailHeader } from '../DetailHeader/DetailHeader';
import { MeasurementAndActivationSection } from '../MeasurementAndActivationSection/MeasurementAndActivationSection';
import { OpportunitySection } from '../OpportunitySection/OpportunitySection';
import { WhyItMattersSection } from '../WhyItMatters/WhyItMattersSection';
import type { SocialBriefDetailProps } from './SocialBriefDetail.types';

export function SocialBriefDetail(props: SocialBriefDetailProps) {
  const { item } = props;

  return (
    <>
      <div className="flex flex-col gap-8 px-10 py-2" data-testid="social-brief-detail">
        <DetailHeader item={item} />
        <OpportunitySection item={item} />
        <WhyItMattersSection item={item} />
        <CustomerUnderstandingSection item={item} />
        <BrandContextSection item={item} />
        <MeasurementAndActivationSection item={item} />
        <CreativeBriefSnapshotSection item={item} />
      </div>
    </>
  );
}
